/* Nutri GlyNAC-ET — Landing Page JS */
(function(){
  'use strict';

  // ---- Pricing data ----
  var ONCE = { 1: 29.99, 3: 74.97, 5: 109.95 };
  var MSRP = { 1: 39.99, 3: 119.97, 5: 199.95 };
  var META = {
    1: { title: '1 Bottle · 30 servings', badge: '', gifts: 'Free shipping over $35' },
    3: { title: '3 Bottles · 90 servings', badge: 'Most Popular', gifts: '✓ Free travel tin  ·  ✓ Longevity Protocol guide' },
    5: { title: '5 Bottles · 150 servings', badge: 'Best Value', gifts: '✓ All gifts  ·  ✓ Free priority shipping' }
  };

  var state = { plan: 'subscribe', pack: 3, gallery: 0 };

  function fmt(n){ return '$' + n.toFixed(2); }
  function priceFor(p){
    return state.plan === 'subscribe' ? ONCE[p] * 0.85 : ONCE[p];
  }
  function savePct(p){
    var cur = priceFor(p), msrp = MSRP[p];
    return Math.round(((msrp - cur) / msrp) * 100);
  }
  function perDay(p){ return priceFor(p) / p / 30; }

  // ---- Update all price/pack UI ----
  function updateBuyBox() {
    var cur = priceFor(state.pack);
    var msrp = MSRP[state.pack];
    var pct = savePct(state.pack);
    var day = perDay(state.pack);
    var perBottle = priceFor(state.pack) / state.pack;

    // Plan buttons
    document.querySelectorAll('[data-plan-btn]').forEach(function(btn){
      btn.classList.toggle('active', btn.dataset.planBtn === state.plan);
    });

    // Pack buttons
    document.querySelectorAll('[data-pack-btn]').forEach(function(btn){
      var p = parseInt(btn.dataset.packBtn);
      btn.classList.toggle('active', p === state.pack);
    });

    // Prices
    document.querySelectorAll('[data-price-main]').forEach(function(el){ el.textContent = fmt(cur); });
    document.querySelectorAll('[data-price-compare]').forEach(function(el){ el.textContent = fmt(msrp); });
    document.querySelectorAll('[data-price-save]').forEach(function(el){ el.textContent = 'Save ' + pct + '%'; });
    document.querySelectorAll('[data-price-sub]').forEach(function(el){
      var subText = '≈ ' + fmt(day) + '/day · ';
      if (state.pack > 1) subText += fmt(perBottle) + ' per bottle · ';
      subText += state.plan === 'subscribe' ? 'ships every 60 days · cancel anytime' : 'one-time purchase';
      el.textContent = subText;
    });

    // Sticky bar
    document.querySelectorAll('[data-sticky-plan]').forEach(function(el){
      el.textContent = state.plan === 'subscribe' ? 'Subscribe & Save' : 'One-time';
    });
    document.querySelectorAll('[data-sticky-day]').forEach(function(el){
      el.textContent = '≈ ' + fmt(day) + '/day';
    });
    document.querySelectorAll('[data-sticky-price]').forEach(function(el){ el.textContent = fmt(cur); });

    // Pack button labels (price column)
    document.querySelectorAll('[data-pack-btn]').forEach(function(btn){
      var p = parseInt(btn.dataset.packBtn);
      var priceEl = btn.querySelector('[data-pack-price]');
      var cmpEl = btn.querySelector('[data-pack-cmp]');
      if (priceEl) priceEl.textContent = fmt(priceFor(p));
      if (cmpEl) cmpEl.textContent = fmt(MSRP[p]);
    });
  }

  // ---- Gallery ----
  function setupGallery(){
    var mainImg = document.getElementById('ng-hero-img');
    if (!mainImg) return;
    document.querySelectorAll('[data-thumb]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var idx = parseInt(btn.dataset.thumb);
        state.gallery = idx;
        mainImg.src = btn.querySelector('img').src;
        document.querySelectorAll('[data-thumb]').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  // ---- Plan toggle ----
  function setupPlanToggle(){
    document.querySelectorAll('[data-plan-btn]').forEach(function(btn){
      btn.addEventListener('click', function(){
        state.plan = btn.dataset.planBtn;
        updateBuyBox();
      });
    });
  }

  // ---- Pack selector ----
  function setupPacks(){
    document.querySelectorAll('[data-pack-btn]').forEach(function(btn){
      btn.addEventListener('click', function(){
        state.pack = parseInt(btn.dataset.packBtn);
        updateBuyBox();
      });
    });
  }

  // ---- Add to cart ----
  function setupAddToCart(){
    document.querySelectorAll('[data-atc]').forEach(function(btn){
      if (btn.dataset.atcBound) return;
      btn.dataset.atcBound = '1';
      btn.addEventListener('click', function(){
        var variantId = btn.dataset.variantId;
        var qty = state.pack;
        var origText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        var body = { items: [{ id: parseInt(variantId), quantity: qty }] };

        // Add selling plan attribute if subscribe mode selected (requires selling plan ID)
        var sellingPlanId = btn.dataset.sellingPlanId;
        if (state.plan === 'subscribe' && sellingPlanId) {
          body.items[0].selling_plan = parseInt(sellingPlanId);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
        .then(function(r){ return r.json(); })
        .then(function(){
          // Fire Meta pixel before redirect
          if (window.fbq) {
            try { fbq('track', 'AddToCart', { value: priceFor(state.pack), currency: 'USD' }); } catch(e){}
          }
          // Go straight to checkout — skip the cart page
          window.location.href = '/checkout';
        })
        .catch(function(){
          btn.disabled = false;
          btn.textContent = origText;
          window.location.href = '/cart';
        });
      });
    });
  }

  // ---- FAQ accordion ----
  function setupFaq(){
    document.querySelectorAll('.ng-faq-item:not([data-fbound])').forEach(function(item){
      item.setAttribute('data-fbound','1');
      var btn = item.querySelector('.ng-faq-q');
      var answer = item.querySelector('.ng-faq-a');
      if (!btn || !answer) return;
      btn.addEventListener('click', function(){
        var isOpen = item.classList.contains('open');
        // Close all
        document.querySelectorAll('.ng-faq-item.open').forEach(function(other){
          other.classList.remove('open');
          other.querySelector('.ng-faq-a').style.maxHeight = null;
        });
        if (!isOpen){
          item.classList.add('open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  // ---- Sticky bar ----
  function setupStickyBar(){
    var bar = document.getElementById('ng-sticky');
    if (!bar) return;
    function onScroll(){
      bar.classList.toggle('show', window.scrollY > 720);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- Init ----
  setupGallery();
  setupPlanToggle();
  setupPacks();
  setupAddToCart();
  setupFaq();
  setupStickyBar();
  updateBuyBox();

})();
